import { apiSlice } from "./apiSlice";
import { PRODUCTS_URL } from "../constants";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all products (Public)

    // Get product by ID (Public)
    getProductById: builder.query({
      query: (productId) => ({
        url: `${PRODUCTS_URL}/${productId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // ✅ Get products by subcategory (Public)

    // Create new product (Vendor only)
    createProduct: builder.mutation({
      query: (data) => ({
        url: PRODUCTS_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),

    // Update product by ID (Vendor only)
    updateProduct: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${PRODUCTS_URL}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),
    toggleVendorStatus: builder.mutation({
      query: ({ vendorId, isActive }) => ({
        url: `${PRODUCTS_URL}/${vendorId}/toggle-status`,
        method: "PUT",
        body: { isActive },
      }),
      invalidatesTags: ["Vendor", "Product"],
    }),
    getVendorProducts: builder.query({
      query: (keyword = "") => ({
        url: `${PRODUCTS_URL}/products${keyword ? `?keyword=${keyword}` : ""}`,
        method: "GET",
      }),
      providesTags: ["Product"],
      keepUnusedDataFor: 5,
    }),
    getInactiveVendorProducts: builder.query({
  query: (keyword = "") => ({
    url: `${PRODUCTS_URL}/vendor/inactive${keyword ? `?keyword=${keyword}` : ""}`,
    method: "GET",
  }),
  providesTags: ["Product"],
  keepUnusedDataFor: 5,
}),

    getExpiringProducts: builder.query({
  query: (vendorId) => ({
    url: `${PRODUCTS_URL}/expiry/${vendorId}`,
    method: "GET",
  }),
  providesTags: ["Product"],
  keepUnusedDataFor: 5,
}),
    getProductsBySubcategory: builder.query({
      query: ({ subcategory, page = 1, limit = 10 }) => ({
        url: `${PRODUCTS_URL}/subcategory/${encodeURIComponent(
          subcategory
        )}?page=${page}&limit=${limit}`,
      }),
      keepUnusedDataFor: 5,
    }),

    getProductsByName: builder.query({
      query: ({
        keyword = "",
        minPrice,
        maxPrice,
        sort,
        pageNumber = 1,
        pageSize = 10,
      }) => {
        const params = new URLSearchParams();

        if (keyword) params.append("keyword", keyword);
        if (minPrice) params.append("minPrice", minPrice);
        if (maxPrice) params.append("maxPrice", maxPrice);
        if (sort) params.append("sort", sort);
        params.append("pageNumber", pageNumber);
        params.append("pageSize", pageSize);

        return {
          url: `${PRODUCTS_URL}/search?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Product"],
      keepUnusedDataFor: 5,
    }),
    getVendorCategorySubcategoryMap: builder.query({
      query: () => ({
        url: `${PRODUCTS_URL}/categories-subcategories`,
        method: "GET",
      }),
      providesTags: ["CategorySubcategory"],
      keepUnusedDataFor: 5,
    }),
    createReview: builder.mutation({
      query: (data) => ({
        url: `${PRODUCTS_URL}/${data.productId}/reviews`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Product"],
    }),
    getProductReferences: builder.query({
      query: ({ keyword = "", category = "" }) => {
        const params = new URLSearchParams();
        if (keyword) params.append("keyword", keyword);
        if (category) params.append("category", category);

        return {
          url: `${PRODUCTS_URL}/reference?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["ProductReference"],
      keepUnusedDataFor: 5,
    }),
    // Delete product by ID (Vendor only)
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `${PRODUCTS_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),
  }),
});

export const {
  useGetProductByIdQuery,
  useGetProductsByNameQuery,
  useToggleVendorStatusMutation,
  useCreateProductMutation,
  useGetVendorProductsQuery,
  useGetVendorCategorySubcategoryMapQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useGetProductsBySubcategoryQuery,
  useCreateReviewMutation,
  useGetProductReferencesQuery,
  useGetExpiringProductsQuery,
  useGetInactiveVendorProductsQuery,
} = productApiSlice;
